import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./utils/login";
import Home from "./Home";
import MemberPage from "./pages/MemberPage";
import { ProtectedRoute } from "./utils/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route path="/member/:id" element={<MemberPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
